import { PERMISSIONS_LIST } from 'components/routing/constants/permissions';

export const getPermissionNameFromPathName = (pathname: string) => {
  const userClientPermissionItem = PERMISSIONS_LIST.find(
    (p) =>
      p.guardedUrls &&
      p.guardedUrls.some((guardedUrl) => pathname.toLowerCase().includes(guardedUrl.toLowerCase()))
  );

  return userClientPermissionItem?.name;
};
